import { combineReducers, configureStore } from '@reduxjs/toolkit';

import notifications from './features/notifications/notifications.slice';
import pvAnalysis from './features/pv-analysis/pv-analysis.slice';
import onsiteVisit from './features/onsite-visit/onsite-visit.slice';
import documentGenerationTemplate from './features/document-generation/document-generation-template.slice';
import documentGenerationNewDocument from './features/document-generation/new-document/document-generation-new-document.slice';
import documentGenerationDataCatalogSlice from './features/document-generation/data-catalog/document-generation-data-catalog.slice';
import offerProcessing from './features/offer-processing/offer-processing.slice';
import offerEvaluation from './features/offer-evaluation/offer-evaluation.slice';
import realEstateAssetManagement from './features/real-estate-asset-management/real-estate-asset-management.slice';
import productRequirementsConfig from './features/product-requirements-config/product-requirements-config.slice';

const reducer = combineReducers({
    notifications,
    pvAnalysis,
    onsiteVisit,
    documentGenerationTemplate,
    documentGenerationNewDocument,
    documentGenerationDataCatalogSlice,
    offerProcessing,
    offerEvaluation,
    realEstateAssetManagement,
    productRequirementsConfig,
});

const store = configureStore({
    reducer,
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export default store;
